import { type DocumentNode, gql } from '@apollo/client';

const deleteFieldMapsConfigMutation: DocumentNode = gql`
  mutation deleteFieldMapsConfigMutation($fieldMapConfigId: ID!) {
    deleteFieldMapConfig(fieldMapConfigId: $fieldMapConfigId) {
      success
    }
  }
`;

export default deleteFieldMapsConfigMutation;
